import { useState } from 'react';
import { Customer } from 'store/customers/customer';
import { isAep5Required, isAep5Verified } from 'views/customers/customer/utils';
import AEP5DocumentUploadModal from '../components/create-customer-drawer/AEP5DocumentUploadModal';

export const customerRequiresAep5Upload = (customer?: Customer | null): boolean =>
    !!customer &&
    !!customer.customerDetails?.confirmedTanUsage &&
    isAep5Required(customer) &&
    !isAep5Verified(customer);

type Options = {
    /** Called with the party's id once its AEP5 document has been uploaded, so it can be reloaded. */
    onUploaded?: (customerId: string) => void;
};

const useAep5DocumentModal = ({ onUploaded }: Options = {}) => {
    const [customerId, setCustomerId] = useState<string | null>(null);

    const checkShowAep5Modal = (customer?: Customer | null) => {
        if (customerRequiresAep5Upload(customer)) {
            setCustomerId(customer!.id);
        }
    };

    const aep5Modal = (
        <AEP5DocumentUploadModal
            open={!!customerId}
            customerId={customerId ?? ''}
            onUploaded={() => customerId && onUploaded?.(customerId)}
            onClose={() => setCustomerId(null)}
        />
    );

    return { checkShowAep5Modal, aep5Modal };
};

export default useAep5DocumentModal;
